interface AppcuesAPI {
  page: () => void;
  identify: (userId: string, properties?: Record<string, unknown>) => void;
}

declare global {
  interface Window {
    Appcues?: AppcuesAPI;
  }
}

export const trackAppcuesPageView = () => {
  try {
    window.Appcues?.page();
  } catch (error) {
    throw new Error(
      `Appcues page tracking failed: ${
        error instanceof Error ? error.message : String(error)
      }`,
      { cause: error },
    );
  }
};
